/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LogCard } from '../../models/log-card';

export interface ApiTapioGetCardsByEntityIdGet$Plain$Params {
  ENTITY_ID?: string;
  Authorization?: string;
}

export function apiTapioGetCardsByEntityIdGet$Plain(http: HttpClient, rootUrl: string, params?: ApiTapioGetCardsByEntityIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LogCard>>> {
  const rb = new RequestBuilder(rootUrl, apiTapioGetCardsByEntityIdGet$Plain.PATH, 'get');
  if (params) {
    rb.query('ENTITY_ID', params.ENTITY_ID, {});
    rb.header('Authorization', params.Authorization, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LogCard>>;
    })
  );
}

apiTapioGetCardsByEntityIdGet$Plain.PATH = '/api/Tapio/getCardsByEntityId';
